import { NgModule } from '@angular/core';

import { ConnectionTypesSharedModule } from 'app/connection-types/connection-types-shared.module';
import { NoteModule } from 'app/note/note.module';
import { EntityCoreModule } from 'entity/entity-core.module';
import { FieldSharedModule } from 'field-shared/field-shared.module';
import { SharedModule } from 'shared/shared.module';
import { ContactAttemptDataEntryComponent } from './components/contact-attempt-data-entry/contact-attempt-data-entry.component';
import { CreateContactAttemptComponent } from './components/create-contact-attempt/create-contact-attempt.component';
import { ContactTrackingDialog } from './dialogs/contact-tracking/contact-tracking.dialog';


const COMPONENTS = [
  CreateContactAttemptComponent,
  ContactAttemptDataEntryComponent
];

const DIALOGS = [
  ContactTrackingDialog
];

const FORMS = [
];

@NgModule({
    imports: [
        SharedModule,
        NoteModule,
        FieldSharedModule,
        EntityCoreModule,
        ConnectionTypesSharedModule
    ],
    declarations: [
        ...FORMS,
        ...COMPONENTS,
        ...DIALOGS
    ],
    providers: [],
    exports: [
        ...FORMS,
        ...COMPONENTS,
        ...DIALOGS
    ]
})
export class ContactTrackingModule { }
